import React from 'react';

import {type RouteData} from '../types';
import {
  INFERENCE_COLLECTION_PATH,
  INFERENCE_COMPARE_PATH,
  INFERENCE_MODEL_PATH,
} from './inferencePaths';

export const INFERENCE_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via HOME_NESTED_ROUTES
    },
    isPrivateRoute: false,
    path: [
      INFERENCE_MODEL_PATH,
      INFERENCE_COLLECTION_PATH,
      INFERENCE_COMPARE_PATH,
    ],
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
];
